import {Box, Text} from "@mantine/core";
import dayjs from "dayjs";
import cx from "clsx";
import classes from "../FocusModeView.module.css";
import {PendingWritesTray} from "@/protocols/studies/components/PendingWritesTray.tsx";
import React from "react";

interface FocusModeBannerProps {
    sessionDuration: number;
    currentTime: string;
}

/**
 * Displays session duration and current time at the top of Focus Mode.
 */
export const FocusModeBanner: React.FC<FocusModeBannerProps> = ({
    sessionDuration,
    currentTime,
}) => {
    return (
        <Box className={cx(classes.titleBar)}>
            <Box>
                <PendingWritesTray/>
            </Box>
            <Box className={cx(classes.title)}>
                <Text size={"xs"} color={"dimmed"}>Session Duration</Text>
                <Text style={{fontSize:"2em"}}>{dayjs.duration(sessionDuration).format("HH:mm:ss")}</Text>
            </Box>
            <Box className={cx(classes.currentTime)}>
                <Text size={"xs"} color={"dimmed"}>Current Time</Text>
                <Text style={{fontSize:"2em"}}>{currentTime}</Text>
            </Box>
        </Box>
    );
};
